<template>
    <!-- 量表题 -->
    <div @click="setEditIndex(index)">
		<p v-if="isBankViewTest" class="my-bank-tag">{{$t('main.ScaleQuestions')}}</p>
        <el-row :gutter="10" class="question-box">
            <el-col v-if="!isBankViewTest" :xs="1" :sm="1" :md="1" :lg="1" :xl="1" class="askxh">
                {{ question.quesIndex + 1 }}
            </el-col>
            <el-col :xs="15" :sm="15" :md="15" :lg="15" :xl="15" class="item_container_title"
                @click="setActiveInput(question.qid)">
                
                <span style="lineHeight: 30px" v-if="isBankViewTest && question.questionsName">{{question.questionsName}}</span>
				<TitleEditor 
                    :isTest="true"
					v-if="!isBankViewTest" 
					class="outline-none" 
					:qid="question.qid" 
					:class="question.qid"  
					:value="question.questionsName" 
                    :actionTitleEditorShow="activeInputId === question.qid"
					@childValueChange="val=>{ question.questionsName = val }" 
				></TitleEditor>
            </el-col>
			<el-col class="setBtn-box" :xs="7" :sm="7" :md="7" :lg="7" :xl="7" v-if="!$route.query.index">
				<OperateWrap
					style="display: flex;
						width: 100%;
						justify-content: end;
					"
					:bankId="$route.query.bankId"	
					:question="question"
				></OperateWrap>
			</el-col>
        </el-row>
        <el-row :gutter="10" style="margin-top: 12px !important;">
            <div >
                <el-col :xs="20" :sm="20" :md="20" :lg="20" :xl="20"
                        class="el_item_option item_container_title" style="margin-left:50px">
                    <div class="inputvalue">
                        <div class="option-box">
                            <template v-if="question.displayStyle !== 0">
                                <img 
                                    class="option-img"
                                    v-for="(item, index) in question.orderSetting"
                                    :key="index"
                                    :src="rateDataList[question.displayStyle].checkedImg" 
                                    alt=""
                                >
                            </template>
                            <template v-else>
                                <el-radio
                                    v-for="(item, index) in question.orderSetting"
                                    :key="index" 
                                    v-model="value" 
                                    :label='question.startNum + index'
                                >{{question.startNum + index}}</el-radio>
                            </template>
                        </div>
                        <div class="tips-box" >
                            <span>{{ question.leftText }}</span>
                            <span>{{ question.rightText }}</span>
                        </div>
                    </div>
                </el-col>
            </div>
        </el-row>
    </div>
</template>
<script>
    import { mapActions, mapState } from 'vuex';
    import TitleEditor from "@/components/titleEditor/titleEditor.vue"
    import OperateWrap from "./collectToBank/operateaWrap.vue"
    export default {
	components: {
    	TitleEditor,
		OperateWrap
	},
        data() {
            return {
                value: 0,
                rateDataList: [
                    {
                        value: 'number',
                        id: 0
                    },
                    {
                        checkedImg:require('@/assets/rate/star_def.png'),
                        unCheckedImg: require('@/assets/rate/star_sel.png'), 
                        value: 'star',
                        id: 1
                    },
                    {
                        checkedImg:require('@/assets/rate/heart_def.png'),
                        unCheckedImg: require('@/assets/rate/heart_sel.png'),
                        value: 'heart',
                        id: 2
                    },
                    {
                        checkedImg:require('@/assets/rate/laugh_def.png'),
                        unCheckedImg: require('@/assets/rate/laugh_sel.png'),
                        value: 'smile',
                        id: 3
                    },
                    {
                        checkedImg:require('@/assets/rate/good_def.png'),
                        unCheckedImg: require('@/assets/rate/good_sel.png'),
                        value: 'thumb',
                        id: 4
                    }
                ],
            }
        },
        props: {
            question: {},
            editOptionIndex: {type:String,default:"0_0"},
            editIndex: {type:Number,default:0},
            isExistPage: {type:Boolean,default:false},
            index: {type:Number,default:0},
            tipsObj: {type: Object},
            imageUrl:{type:Object},
            // 管理题库时查看试题 只可以删除
            isBankViewTest: {
                type: Boolean,
                default: false
            },
        },
        computed: {
            ...mapState(['activeInputId']),
        },
        methods: {
            ...mapActions(['setActiveInput']),
            setEditIndex(index){
                this.$emit("setEditIndex",index);
            },
        },
    }
</script>

<style scoped lang="scss">
.inputvalue {
    .tips-box, .option-box{
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 12px;
    }
    .option-box .option-img{
        width: 24px;
        height: 22px;
    }
}
.askxh {
    line-height: 40px;
    text-align: right;
}
.item_container_title {
    padding-left: 0px !important;
    padding-right: 0px !important;
}
</style>
